import React, { useEffect, useState, useRef } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { RiLoader4Line } from 'react-icons/ri';
import ReactInputMask from 'react-input-mask';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../providers/auth';
import http from '../../../services/Api';
import client from "../../../services/Api";
import swal from 'sweetalert';

import './index.css';
import { useForm } from 'react-hook-form';

function RegisterForm() {
    const [loading, setLoading] = useState(false)
    const [profiles, setProfiles] = useState([]);
    const { register, handleSubmit, errors, watch } = useForm();
    const password = useRef({});
    const history = useHistory();
    const { user } = useAuth();
    password.current = watch("password", "");

    useEffect(() => {
        getProfiles();
    }, [])

    async function getProfiles() {
        setLoading(true);
        try {
            let res = await http.get("/api/acl/all")
            setProfiles(res.data.content);
        } catch (error) {
            console.log(error);
            swal("Não foi possível carregar os perfis de usuário. Recarregue a tela.", {
                title: "Erro!",
                icon: "error",
            })
        } finally {
            setLoading(false);
        }
    }

    const businessErrorMessage = e => {
        if (e && e.response && e.response.status < 500 && e.response.data && e.response.data.error)
            return e.response.data.error;

        return null;
    }

    const verifyEmail = async email => {
        const response = await http.post(`/api/user/email-available`, { 'email': email });
        return response.data === true || response.data === 'true';
    }

    const registerUser = async data => {
        const { name, username, email, phone, password, userType } = data;

        const response = await client.post(`/api/user/create`, {
            name,
            username,
            email,
            phone,
            password,
            profile: {
                _id: userType
            },
            available_devices: []
        });

        return response.data;
    }

    async function vinculateUserToEnterprise(newUser) {
        await http.post(`/api/client/link/${user.enterprise.id}`, {
            users: [
                {
                    id: newUser._id,
                    isOwner: false
                }
            ]
        });
    }

    const save = async data => {
        setLoading(true);

        try {
            if (await verifyEmail(data.email)) {
                swal("Este e-mail já está cadastrado. Utilize outro e-mail.", {
                    title: "Atenção!",
                    icon: "warning",
                })
                return;
            }

            const newUser = await registerUser(data);

            try {
                await vinculateUserToEnterprise(newUser);
            } catch (e) {
                console.log(e);
                swal("O usuário foi criado, mas não foi possível vinculá-lo à empresa. Não cadastre novamente com o mesmo e-mail: procure o suporte.", {
                    title: "Atenção!",
                    icon: "warning",
                })
                return;
            }

            swal("Usuário cadastrado com sucesso!", {
                title: "Sucesso!",
                buttons: {
                    login: {
                        text: "Voltar para Meus Dispositivos",
                        value: "my-devices",
                    },
                },
                icon: "success",
            })
            .then((value) => {
                if (value === 'my-devices') {
                    history.push('/my-devices');
                }
            });
        } catch (e) {
            console.log(e);
            swal(businessErrorMessage(e) || "Ocorreu um erro ao tentar cadastrar esse usuário!", {
                title: "Erro!",
                icon: "error",
            })
        } finally {
            setLoading(false);
        }
    }


    return (
        <div className="RegisterUser-Form">
            <h1>Cadastro de usuário</h1>
            <Form method="POST" onSubmit={handleSubmit(save)}>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">
                        Nome *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            type="text"
                            name="name"
                            ref={register}
                            placeholder="Digite seu nome"
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">
                        Usuário *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            type="text"
                            name="username"
                            ref={register}
                            placeholder="Digite seu nome de usuário"
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">
                        Email *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            type="Email"
                            name="email"
                            ref={register}
                            placeholder="Digite seu email"
                        />
                    </Col>
                </Form.Group>
                <Form.Group name="password" controlId="password" as={Row}>
                    <Form.Label column sm="2">
                        Senha *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            name="password"
                            placeholder="Digite sua Senha"
                            type="password"
                            ref={register({
                                required: "Você deve escolher uma senha",
                                minLength: {
                                    value: 8,
                                    message: "A senha deve ter no mínimo 8 caracteres"
                                },
                                pattern: {
                                    value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
                                    message: "A senha deve conter ao menos um caractere maiúsculo e um caractere especial"
                                }
                            })} />
                        <span className="form-error-register">
                            {errors.password && <p>{errors.password.message}</p>}
                        </span>
                    </Col>
                </Form.Group>
                <Form.Group controlId="confirmPassword" as={Row}>
                    <Form.Label column sm="2">
                        Confirmar Senha *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            name="password_repeat"
                            type="password"
                            placeholder="Confirme sua Senha"
                            ref={register({
                                validate: value =>
                                    value === password.current || "As senhas devem ser iguais"
                            })} />
                        <span className="form-error-register">
                            {errors.password_repeat && <p>{errors.password_repeat.message}</p>}
                        </span>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="phone">
                    <Form.Label column sm="2">
                        Telefone
                    </Form.Label>
                    <Col sm="10">
                        <ReactInputMask
                            // mask="(99) 99999 9999"
                            id="inlineFormInputGroupUsername2"
                            placeholder="Digite seu telefone"
                            type="text"
                            name="phone"
                            required
                            className="form-control"
                        // pattern={[
                        //   '^[0-9]*$'
                        // ]}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">
                        Perfil do Usuário
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control as="select" name="userType" ref={register}>
                            {profiles.map(item => item.id != "6086f50d46258e47f28ec9d5" ? <option value={item._id}>{item.name}</option> : null )}
                        </Form.Control>
                    </Col>
                </Form.Group>
                <Button variant="primary" type="submit">
                    {loading ?
                        <RiLoader4Line className="spin" />
                        :
                        'Salvar'
                    }
                </Button>
            </Form>
        </div>
    );
}

export default RegisterForm;